import { LocaleSelector } from '@components/locale-selector';
import { Typography } from '@leegality/leegality-react-component-library';
import PropTypes from 'prop-types';
import React from 'react';

const FeedbackShellHeader = ({ title, logoUrl, brandColor }) => (
  <div className="flex items-center justify-between gap-3 px-3 py-1 bg-gray-50 border-b border-gray-100">
    <div className="w-16 flex-shrink-0">
      {logoUrl && <img src={logoUrl} alt="" className="object-contain object-left max-h-8 max-w-[64px]" />}
    </div>
    <Typography
      tag={Typography.Tags.SPAN}
      variant={Typography.Variants.sm}
      fontWeight={Typography.FontWeight.semibold}
      color={Typography.Colors.gray900}
      className="flex-1 text-center truncate"
    >
      {title}
    </Typography>
    <div className="w-16 flex-shrink-0 flex justify-end">
      <LocaleSelector ctaColor={brandColor} popoverClassName="feedback-locale-popover" />
    </div>
  </div>
);

FeedbackShellHeader.propTypes = {
  title: PropTypes.string,
  logoUrl: PropTypes.string,
  brandColor: PropTypes.string,
};

FeedbackShellHeader.defaultProps = {
  title: '',
  logoUrl: '',
  brandColor: null,
};

export default FeedbackShellHeader;
